const IDLE_ENABLED = true; // set to false to disable in dev

const IDLE_TIMEOUT = 15 * 60 * 1000;
export const WARNING_BEFORE = 1 * 60 * 1000;

const EVENTS = ['mousemove', 'keydown', 'mousedown', 'click', 'touchstart', 'scroll'];

export function createIdleTimer({ onWarn, onLogout }) {
  if (!IDLE_ENABLED) return { start() {}, stop() {}, reset() {} };

  let warnTimer = null;
  let logoutTimer = null;

  function reset() {
    clearTimeout(warnTimer);
    clearTimeout(logoutTimer);
    warnTimer = setTimeout(onWarn, IDLE_TIMEOUT - WARNING_BEFORE);
    logoutTimer = setTimeout(onLogout, IDLE_TIMEOUT);
  }

  function start() {
    EVENTS.forEach(e => window.addEventListener(e, reset, { passive: true }));
    reset();
  }

  function stop() {
    clearTimeout(warnTimer);
    clearTimeout(logoutTimer);
    EVENTS.forEach(e => window.removeEventListener(e, reset));
  }

  return { start, stop, reset };
}
